
import axios from "axios";
import config from "../config";

const apiurl = config.API_URL;


export const contactUs = async (data) => {
    try {
        const response = await axios.post(
            `${apiurl}/api/v1/contact-us`,
            data
        );
        return response.data;
    } catch (error) {
        return Promise.reject(error.response.data);
    }
}


// export const getHomePageCrousel = async () => {
//     try {
//         const response = await axios.get(`${apiurl}/api/v1/home-page-crousel`);
//         return response.data;
//     } catch (error) {
//         return Promise.reject(error.response.data);
//     }
// }

export const getHomePageCrousel = async () => {
    try {
        const response = await axios.get(`${apiurl}/api/v1/home-page`);
        return response.data;
    } catch (error) {
        return Promise.reject(error.response.data);
    }
}


//https://api.autovertest.com/api/v1/testimonial-users
export const getTestimonialUsers = async () => {
    try {
        const response = await axios.get(`${apiurl}/api/v1/testimonial-users`);
        return response.data;
    } catch (error) {
        return Promise.reject(error.response.data);
    }
}

// API to Unsubscribe from the Newsletter
export const unsubscribeNewsletter = async (token) => {
    try {
        const response = await axios.post(
            `${apiurl}/api/v1/newsletter-unsubscribe?token=${token}`
        );
        return response.data;
    } catch (error) {
        return Promise.reject(error.response.data);
    }
}


//mailUnsubscribed
export const mailUnsubscribed = async (email) => {
    try {
        const response = await axios.get(
            `${apiurl}/api/v1/mail-unsubscribed?email=${email}`
        );
        return response.data;
    } catch (error) {
        return Promise.reject(error.response.data);
    }
}